import React from 'react';
import {useTranslation} from 'react-i18next';
import SMCTextInput from '../../../components/Simple/SMCTextInput';
import SMCModalButtonContainer from '../../../components/core/SMCModal/SMCModalButtonContainer';
import SMCModalBody from '../../../components/core/SMCModal/SMCModalBody';
import SMCButton from '../../../components/Simple/SMCButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';



function GatewayWizardStepOne({
    wizardVars
}) {
    const { t } = useTranslation();
    
    const {
        onRequestClose,
        setWizardStep,
        name, setName,
        description, setDescription,
    } = wizardVars;

    const nextButtonFunction = () => {
        if (name) {
            setWizardStep(step => step + 1);
        } else {
            alert('Name is a required field');
        }
    }

    return (
        <>
            <SMCModalBody>
                {/* Description */}
                <SMCTextInput
                    value={name}
                    onChange={e => setName(e.target.value)}
                    label={t('SMC_GATEWAY_NAME')}
                />
                {/* Enabled */}
                <SMCTextInput
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                    label={t("SMC_GATEWAY_DESCRIPTION")}
                />
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={nextButtonFunction} style={{ marginRight: 5 }}>
                    {t('SMC_GEN_WIZNEXT')}
                    <FontAwesomeIcon style={{ marginTop: '3px', marginLeft: '5px' }} color="grey" icon="arrow-circle-right" />
                </SMCButton>
                <SMCButton onClick={onRequestClose}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </>
    );
}

export default GatewayWizardStepOne;